import { useSyncExternalStoreWithSelector as a } from "use-sync-external-store/with-selector";
import { useEvent as t } from './hooks/use-event.js';
import { shallowEqual as o } from './machine.js';
function S(e, n) {
  let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : o;
  return a(t(i => e.subscribe(s, i)), t(() => e.state), t(() => e.state), t(n), r);
}
function s(e) {
  return e;
}
export { S as useSlice };